import React from 'react';
import { Field, inputClasses } from './Field';
interface DateFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string;
  hint?: string;
  className?: string;
}
export function DateField({
  id,
  label,
  value,
  onChange,
  required,
  error,
  hint,
  className
}: DateFieldProps) {
  return <Field id={id} label={label} required={required} error={error} hint={hint} className={className} data-id="element-73" data-mp="3ug8h5w6c8dbl">
      <input id={id} name={id} type="date" value={value} aria-required={required} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined} onChange={e => onChange(e.target.value)} className={inputClasses(Boolean(error), 'numeric')} data-id="element-74" data-mp="3pgni7lr644yv" />
    </Field>;
}